import { Application } from '@hotwired/stimulus'
import AdminMenuController from './admin_menu_controller'
import AutoSubmitController from './auto_submit_controller'
import BackLinkController from './back_link_controller'
import CatalogFiltersController from './catalog_filters_controller'
import DeliveryFieldsController from './delivery_fields_controller'
import ListReturnController from './list_return_controller'
import RowLinkController from './row_link_controller'
import ShowMoreController from './show_more_controller'
import SyncPollerController from './sync_poller_controller'

const application = Application.start()
application.register('admin-menu', AdminMenuController)
application.register('auto-submit', AutoSubmitController)
application.register('back-link', BackLinkController)
application.register('catalog-filters', CatalogFiltersController)
application.register('delivery-fields', DeliveryFieldsController)
application.register('list-return', ListReturnController)
application.register('row-link', RowLinkController)
application.register('show-more', ShowMoreController)
application.register('sync-poller', SyncPollerController)
